<template>
  <b-modal
    id="modal-category"
    :title="$t('category.modal.'+mode+'.'+type)"
    size="lg"
    button-size="sm"
    @show="onShow"
    @shown="onShown"
  >
    <b-alert
      variant="warning"
      :show="(mode == 'edit') ? true : false"
    >
      <font-awesome-icon
        :icon="['fal', 'exclamation-triangle']"
        class="fa-lg"
      /> {{ $t('building.warningEdit') }}
    </b-alert>
    <b-form @submit.prevent="onSubmit">
      <b-row>
        <b-col>

          <!-- NAME -->

          <b-form-group
            type="text"
            id="input-group-2"
            :label="$t('project.name')+ '*'"
            label-for="name"
            label-cols-sm="3"
            label-cols-lg="2"
            content-cols-sm
            content-cols-lg="10"
          >
            <b-form-input
              id="name"
              v-model="form.name"
              :value="form.name"
              ref="nameInput"
              type="text"
              @blur="$v.form.name.$touch"
            ></b-form-input>
            <label
              class="error"
              v-if="!$v.form.name.required && $v.form.name.$dirty"
            >{{ $t('validate.requiredFields') }}</label>
            <label
              class="error"
              v-if="!$v.form.name.maxLength && $v.form.name.$dirty"
            >{{ $t('validate.maxLength', { val: '150' }) }}</label>
            <label
              class="error"
              v-if="!$v.form.name.minLength && $v.form.name.$dirty"
            >{{ $t('validate.minLength', { val: '1' }) }}</label>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- COLOR SELECTION FOR FAMILY -->

      <b-row v-if="type === 'family'">
        <b-col>
          <b-form-group
            id="color-group"
            :label="$t('category.modal.color') + '*'"
            label-for="color"
            label-cols-sm="3"
            label-cols-lg="2"
            content-cols-sm
            content-cols-lg="10"
          >
            <div class="color-options">
              <div
                v-for="color in colors"
                :key="color"
                :class="['color-circle-outer', { 'selected-color': form.color === color }]"
                @click="selectColor(color)"
              >
                <div
                  :style="{ backgroundColor: color }"
                  class="color-circle-inner"
                ></div>
              </div>
            </div>
          </b-form-group>
        </b-col>
      </b-row>

    </b-form>

    <template #modal-footer="{ hide }">
      <div class="d-flex justify-content-between align-items-center w-100">
        <small class="text-muted">
          * {{ $t('validate.required') }}
        </small>
        <div>
          <b-button
            size="sm"
            variant="light"
            @click="hide"
          >
            {{ $t('action.cancel') }}
          </b-button>
          <b-button
            type="button"
            @click="onSubmit"
            size="sm"
            variant="primary"
          >
            {{ $t('action.save') }}
          </b-button>
        </div>
      </div>
    </template>

  </b-modal>

</template>

<script>
import axiosResource from '@/utils/axiosResource';
import {
  required,
  minLength,
  maxLength,
  sameAs,
} from 'vuelidate/lib/validators';

export default {
  name: 'modal-category',
  props: {
    mode: String,
    type: String,
    uuid: String,
    label: String,
    color: String,
  },
  data() {
    return {
      projectUuid: '',
      form: {
        name: '',
        color: '',
      },
      colors: [
        '#FF3B30',
        '#FF9500',
        '#FFCC00',
        '#34C759',
        '#00C7BE',
        '#30B0C7',
        '#32ADE6',
        '#007AFF',
        '#5856D6',
        '#AF52DE',
        '#A2845E',
        '#000000',
        '#8E8E93',
      ],
    };
  },
  validations() {
    const isFamily = this.type === 'family';
    return {
      form: {
        name: {
          required,
          minLength: minLength(1),
          maxLength: maxLength(150),
        },
        color: isFamily
          ? {
              required,
            }
          : {}, // Skip validation if not family
      },
      acceptTerms: {
        required,
        sameAs: sameAs(() => true),
      },
    };
  },
  methods: {
    onShown() {
      this.$nextTick(() => {
        if (this.$refs.nameInput) {
          this.$refs.nameInput.focus();
        } else {
          console.error('nameInput ref is not defined');
        }
      });
    },
    onShow() {
      const clgStyle = 'color: blue;font-size:14px;font-weight: 400;';
      console.log('%c' + 'ModalProject onShow()', clgStyle);
      console.log('Mode:', this.mode);
      console.log('UUID:', this.uuid);
      console.log('Label:', this.label);
      console.log('Color:', this.color);
      console.log('Type:', this.type);

      if (this.mode === 'edit') {
        this.form.name = this.label;
      } else {
        this.form.name = '';
      }

      this.form.color = this.color;
      // this.$nextTick(() => {
      //   this.$refs.nameInput.focus();
      // });
      this.$v.$reset();

      if (this.type === 'family' && !this.form.color) {
        this.form.color = this.colors[0]; // Automatically select the first color
      }
    },
    prepareForm() {
      const clgStyle = 'color: red;';
      console.log('%c' + `Prepare form to ${this.mode}`, clgStyle);
      console.log(this.category);
      this.form.name = this.category.name;
    },
    selectColor(color) {
      this.form.color = color;
    },
    onSubmit() {
      this.$v.form.$touch();
      console.log(this.type);
      if (this.$v.form.$invalid) {
        this.submitStatus = 'ERROR';
      } else {
        this.$store.commit('SET_LOADING', true);

        if (this.mode === 'edit') {
          this.$store
            .dispatch('updateCategory', {
              type: this.type,
              itemUuid: this.uuid,
              categoryData: this.form,
            })
            .then(() => {
              this.$bvModal.hide('modal-category');
              // this.$store.commit('SET_LOADING', false);
            })
            .catch((err) => {
              console.log(err);
              this.$globalSwal.error('test');
            });
          this.$emit('update-category', {
            type: this.type,
            itemUuid: this.uuid,
            categoryData: {
              name: this.form.name,
            },
          });
        } else {
          let parentUuid;
          switch (this.type) {
            case 'activity':
              parentUuid = this.uuid;
              break;
            case 'specialty':
              parentUuid = this.uuid;
              break;
            case 'remark':
              parentUuid = this.uuid;
              break;
            default:
              parentUuid = '';
          }
          this.$store
            .dispatch('createCategory', {
              type: this.type,
              name: this.form.name,
              color: this.form.color,
              projectUuid: this.$store.getters.currentProject.uuid,
              familyUuid: this.type === 'activity' ? parentUuid : undefined,
              activityUuid: this.type === 'specialty' ? parentUuid : undefined,
              specialtyUuid: this.type === 'remark' ? parentUuid : undefined,
            })
            .then(() => {
              this.$bvModal.hide('modal-category');
            })
            .catch((err) => {
              console.log(err);
              this.$globalSwal.serverError();
            });
        }
      }
    },
  },
};
</script>
<style scoped>
.color-options {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.color-circle-outer {
  width: 31px;
  height: 31px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid transparent;
}

.color-circle-inner {
  width: 26px;
  height: 26px;
  border-radius: 50%;
}

.color-circle-outer.selected-color {
  border-color: red;
}
</style>